<template>
    <table class="striped-table">
        <thead>
            <tr>  
                <th
                    v-for="(column, index) in columns"
                    :key="index"
                >
                    <slot :name="`th-${column.name}`">
                        {{ column.label }}
                    </slot>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr 
                v-for="(row, indexRow) in rows"
                :key="`tr-${indexRow}`"
            >
                <slot :name="`${indexRow}`" :row="row">
                    <td
                        v-for="(column, indexCol) in columns"
                        :key="`td-${indexCol}`"
                        :style="{ textAlign: getAlignStyle(column.align), ...getStyle(column.style) }"
                    >
                        <slot :name="`td-${column.name}`" :row="row" :indexRow="indexRow">
                            <span>{{ column.format ? column.format(row[column.field], row) : row[column.field] }}</span>
                        </slot>
                    </td>
                </slot>
            </tr>
            <slot name="tbody"></slot>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'custom-table',
    props: {
        columns: {
            type: Array,
            required: true
            //example -> [{ name: 'iron', label: 'Iron (%)', field: 'iron', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10), format: (val, row) => `${val}%` }]
        },
        rows: {
            type: Array,
            required: true
        },
    },
    methods: {
        getAlignStyle (align) {
            return align ? `${align}` : '';
        },
        getStyle (style) {
            return style ? style : {};
        }
    }
}

</script>